import { makeStyles } from '@mui/styles'
import { MyAccountTheme, MyAccountRadioGroupClasses } from '@dxp-module/themes'

const radioGroupStyles = makeStyles<
  MyAccountTheme,
  Record<string, never>,
  MyAccountRadioGroupClasses
>(
  ({ palette }) => ({
    root: {},
    item: {},
    itemChecked: {},
    itemDisabled: {},
    itemRoot: {},
    radioGroup: {
      display: 'inline-flex',
      flexDirection: 'row',
    },
    row: {},
    label: {
      color: palette.common.black,
      position: 'relative',
      transform: 'none',
      '&.Mui-focused': {
        color: palette.common.black,
      },
    },
  }),
  { name: 'MyAccount_RadioGroup' }
)

export default radioGroupStyles
